import React from 'react';

const STEPS_WITH_CO    = ['Wohnung', 'Haushalt', 'Personalien', 'Mitbewerber', 'Zusammenfassung'];
const STEPS_WITHOUT_CO = ['Wohnung', 'Haushalt', 'Personalien', 'Zusammenfassung'];

const AppStepIndicator = ({ step, numberAdults }) => {
    const hasCo = numberAdults > 1;
    const steps = hasCo ? STEPS_WITH_CO : STEPS_WITHOUT_CO;
    const activeIndex = !hasCo && step === 4 ? 3 : step;

    return (
        <ul className="step-progressbar">
            {steps.map((label, i) => {
                let className = 'step-progressbar__item';
                if (i < activeIndex) className += ' step-progressbar__item--complete';
                if (i === activeIndex) className += ' step-progressbar__item--active';
                return <li key={i} className={className}>{label}</li>;
            })}
        </ul>
    );
};

export default AppStepIndicator;